import {
  REPORTS_PAGE,
  MAIN_REPORT_TAB,
  TRANSACTION_REPORT_TAB,
} from "../../constants";
import { useParamTabs } from "..";

export type UseReportsHook = {
  param: string;
};
export const paramsToTabs = {
  main: MAIN_REPORT_TAB,
  transaction: TRANSACTION_REPORT_TAB,
};
export const useReports = () =>
  useParamTabs({
    paramKey: "type",
    pageKey: REPORTS_PAGE,
    paramsToTabs,
  });
